import config from '../../config';

const CRYSTAL = 'crystal';
const ELECTRIC = 'electric';
const FIRE = 'fire';
const ELEMENT_TYPES = [CRYSTAL, ELECTRIC, FIRE];
const POOL_COUNT = 8;
const SPAWN_Y = -150;
const SCROLL_RATIO = 1.25;
// const SCROLL_RATIO = 1.5;
const SPAWN_THRESHOLD_MIN = 200;
const SPAWN_THRESHOLD_MAX = 600;
const POINTS_PER_BARRIER = 10;

let dataManager;
let soundManager;

class Barriers {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;

    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');

    this.group = g.add.group();
    this.pool = {};
    this.spawnCount = 0;
    this.burstCount = 0;
    this.totalBurstCount = 0;
    this.burstStreak = 0;
    this.spawnThreshold = _.random(SPAWN_THRESHOLD_MIN, SPAWN_THRESHOLD_MAX);
    this.lastBarrierSpawned = null;

    let group = this.group;
    let pool = this.pool;

    _.each(ELEMENT_TYPES, (element) => {
      pool[element] = [];
      let p = pool[element];
      for (let i = 0; i < POOL_COUNT; i++) {
        let b = group.create(config.CENTER_X, SPAWN_Y, 'barriers');
        // b.setFrame(`${element}.png`);
        b.play(`${element}-barrier-animate`);
        b.setActive(false);
        b.setVisible(false);
        b.alive = false;
        b.easedAlpha = 1;
        b.targetAlpha = 1;
        b.smoothAlpha = 1;
        b.prevAlpha = 1;
        b.element = element;
        b.update = () => {
          // console.log('barrier update');
          b.easedAlpha -= (b.easedAlpha - b.targetAlpha) / 4;
          b.smoothAlpha = ~~(b.easedAlpha * config.ROUND) / config.ROUND;
          if (b.smoothAlpha !== b.prevAlpha) {
            b.setAlpha(b.smoothAlpha);
            b.prevAlpha = b.smoothAlpha;
            if (b.smoothAlpha === 0) {
              this.recycle(b);
            }
          }
        };
        p.push(b);
      }
    });

    let explosions = {};
    _.each(ELEMENT_TYPES, (element) => {
      let exp = g.add.sprite(config.CENTER_X, 0, 'element-burst');
      exp.setVisible(false);
      explosions[element] = exp;
    });
    this.explosions = explosions;

    group.runChildUpdate = true;
    // console.log('Constructor', this);
  }
  reset () {
    this.spawnCount = 0;
    this.burstCount = 0;
    this.lastBarrierSpawned = null;
  }
  recycle (barrier) {
    barrier.setActive(false);
    barrier.setVisible(false);
    barrier.alive = false;
    barrier.setY(SPAWN_Y);
  }
  spawn () {
    // TODO
    let g = this.g;
    let group = this.group;
    let inactive = _.filter(group.getChildren(), ['active', false]);
    if (inactive.length === 0) {
      console.warn('No inactive barriers to spawn. You should not get this');
      return false;
    }
    let barrier = inactive[_.random(inactive.length - 1)];
    barrier.setY(SPAWN_Y);
    barrier.scrollOrigin = g.levelData.scrollPosition;
    barrier.setActive(true);
    barrier.setVisible(true);
    barrier.alive = true;
    barrier.easedAlpha = 1;
    barrier.targetAlpha = 1;
    barrier.smoothAlpha = 1;
    this.spawnCount++;
    this.lastBarrierSpawned = barrier;
    this.spawnThreshold = _.random(SPAWN_THRESHOLD_MIN, SPAWN_THRESHOLD_MAX);
  }
  get spawnDistanceElapsed () {
    if (this.lastBarrierSpawned) {
      return this.lastBarrierSpawned.y + Math.abs(SPAWN_Y);
    }
    return 0;
  }
  get isSpawnReady () {
    return this.spawnDistanceElapsed > this.spawnThreshold;
  }
  update () {
    let g = this.g;
    let group = this.group;
    let active = _.filter(group.getChildren(), 'active');
    _.each(active, (barrier) => {
      let y = (barrier.scrollOrigin - g.levelData.scrollPosition) * SCROLL_RATIO + SPAWN_Y;
      y = ~~(y * config.ROUND) / config.ROUND;
      if (y > config.HEIGHT + 130) {
        // don't warn because this is actually useful for the special
        // console.warn('Auto Barrier Recycle');
        barrier.setActive(false);
        barrier.setVisible(false);
        barrier.alive = false;
      } else {
        barrier.setY(y);
      }
    });
    _.each(this.explosions, (exp) => {
      if (exp.follow) {
        exp.setY(exp.follow.y);
      }
    });
  }
  get alive () {
    let group = this.group;
    return _.filter(group.getChildren(), 'alive');
  }
  burst (barrier, isSpecial = false) {
    let burstParticles = this.g.burstParticles;
    burstParticles[barrier.element].explode(100);
    barrier.alive = false;
    barrier.targetAlpha = 0;
    let exp = this.explosions[barrier.element];
    exp.angle = _.random(0, 359);
    exp.setY(barrier.y);
    exp.follow = barrier;
    exp.play(`${barrier.element}-burst`);
    this.burstCount++;
    this.totalBurstCount++;
    this.burstStreak++;
    dataManager.addPoints(isSpecial ? POINTS_PER_BARRIER * 2 : POINTS_PER_BARRIER);
    if (this.burstStreak >= dataManager.achievements.HotStuff.hardCodeRequired) {
      dataManager.unlockAchievement(dataManager.achievements.HotStuff);
    }

    if (this.totalBurstCount % 10 === 0) {
      this.g.time.delayedCall(250, () => {
        soundManager.playSound('ben-hit');
      });
    }
    soundManager.playSound(`barrier-${barrier.element}`);
  }
  endBurstStreak () {
    this.burstStreak = 0;
  }
  fadeAll () {
    this.lastBarrierSpawned = null;
    _.each(this.alive, (barrier) => {
      barrier.targetAlpha = 0;
      barrier.alive = false;
      this.spawnCount--;
    });
  }
}

export default Barriers;
